import './happyday/style';
import FormStructure from './happyday/form_structure';

export default FormStructure;